import FileSave from 'file-saver'
import {sessionGetUserInfo} from "@/assets/js/utils.session";
import axios from "axios";
import fa from "element-ui/src/locale/lang/fa";
/**
 * 是否对象
 */
export function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * 从多级列表数组中查找[id,id,id,....]匹配的数据项并返回
 * @param list        {array}   多级列表数据
 * @param valueArray  {array}   多级列表对应匹配值
 * @param index       {number}  匹配层级,从0开始自增
 * @param prop        {object}  其他可配置化参数
 * @returns {*}
 */
export function findChildrenItem(list = [],valueArray = [],index = 0,prop={}){

  prop = Object.assign({value:'value',children:'children',resultType:''},prop);
  let results = [list.find(item => item[prop.value] === valueArray[index])];
  if(results[0] && (valueArray.length > ++index)) results.push(...findChildrenItem(results[0][prop.children],valueArray,index,prop));
  if(prop.resultType.toLowerCase() === 'array' || index !==1 ) return results;
  else return results[results.length - 1];
}

/**
 * 将多级列表数组从截取对应层级的新数组
 * @param list
 * @param prop
 * @param level
 */
export function setArrayChildrenLevel(list = [],prop = {},level = 0){
  prop = Object.assign({children:'children',level:3},prop);
  if(level === 0) try {
    list = JSON.parse(JSON.stringify(list));
  }catch (e) {
    list = []
  }
  list.forEach(item=>{
    let children = item[prop.children];
    if(level + 1 >= prop.level){
      delete item[prop.children];
    }else if(children instanceof Array){
      setArrayChildrenLevel(children,prop,level + 1);
    }
  });
  return list
}

/**
 * 处理搜索数据
 * @param data
 */
export function disposeSearchData(data){
  if(data.searchType && data.searchValue){
    data[data.searchType] = data.searchValue
  }
  if(data.searchType) delete data.searchType;
  if(data.searchValue) delete data.searchValue;
  objectRemoveEmpty(data);
  return data
}

/**
 * 清空对象中值为空的key
 * @param data
 * @returns {*}
 */
export function objectRemoveEmpty (data) {
  let keys = Object.keys(data).filter(res=>empty(data[res]));
  keys.forEach(key=>{
    delete data[key]
  });
  function empty(res){
    if(res === 0) return false;
    return isEmpty(res)
  }
  return data
}

/**
 * 判断为空
 * @param val
 * @returns {boolean}
 */
export const isEmpty = function(val) {
  // null or undefined
  if (val === null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]': {
      return !val.size;
    }
    // Plain Object
    case '[object Object]': {
      return !Object.keys(val).length;
    }
  }

  return false;
};

/**
 * 下载Excel
 * @param url
 */
export function downloadExcel(url = ''){
  if(!url) return false;
  try {
    window.location.href = url;
  }catch (e) {
    window.location = url;
  }
}
export function downFile(fileName,fileUrl){
  let pom = document.createElement("a");

  pom.setAttribute("target","_blank");
  pom.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," +encodeURIComponent(fileUrl)
  );
  pom.setAttribute("download",fileName);
  if(document.createEvent){
    let event = document.createEvent("MouseEvents");
    event.initEvent("click",true,true);
    pom.dispatchEvent(event);
  }else {
    pom.click()
  }
}

export function downloadPDF(URLToPDF,PDFName) {
  let oReq = new XMLHttpRequest();
  oReq.open("GET", URLToPDF, true);
  oReq.responseType = "blob";
  oReq.onload = function() {
    let file = new Blob([oReq.response], {
      type: 'application/pdf'
    });
    FileSave.saveAs(file, PDFName);
  };
  oReq.send();
}

/**
 * 将字符串截取逗号','转为数组
 * @param str
 * @param s
 * @returns {*}
 */
export function stringToArray(str='',s=',') {
  if(!str) return [];
  let reg = new RegExp(s,'ig');
  if(!reg.test(str)) return [str];
  return str.split(s);
}

/**
 * 将 数组中有值的label、value 隐射为对应{value:label}
 * @param keyName
 * @param arr
 * @param prop
 * @returns {{}}
 */
export function mapFromArrayToObject(arr = [], prop = {}) {
  if (!Array.isArray(arr)) return {};
  if (arr.length <= 0) return {};
  prop = Object.assign({label: 'label', value: 'value'}, prop);
  let obj = {};
  arr.forEach(res => {
    if (res[prop.label] !== '全部' && res[prop.label] !== undefined && res[prop.value] !== undefined) {
      obj[res[prop.label]] = res[prop.value];
      obj[res[prop.value]] = res[prop.label];
    }
  });
  return obj;
}

/**
 * 将数组对象中 对应的key转换为label,value
 * @param list
 * @param prop
 * @returns {*}
 */
export function mapArrayObjectKeyName(list = '', prop = {}) {
  if (!Array.isArray(list)) return [];
  if (list.length <= 0) return [];
  prop = Object.assign({label: 'label', value: 'value'}, prop);
  list.forEach(res => {
    if (typeof res.label === "undefined" && res[prop.label]) {
      res.label = res[prop.label];
    }
    if (typeof res.value === "undefined" && res[prop.value]) {
      res.value = res[prop.value];
    }
  });
  return list;
}

export function dateFormat (originVal) {
  const dt = new Date(originVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() <= 9 ? ('0' + (dt.getMonth() + 1) + '') : ((dt.getMonth() + 1) + ''))

  const d = (dt.getDate() <= 9 ? ('0' + dt.getDate() + '') : (dt.getDate() + ''))

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
}

export function isBuild() {
  let obj = window.__PRERENDER_INJECTED;
  return isObject(obj) && !!obj.build ? obj : false;
}

export function bodyAppendElement(text='',tag){
  let html = document.createElement(tag||'p');
  html.innerText = text;
  document.body.appendChild(html);
}

function _randomString(len = 16) {
  let $chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345678_';
  let maxPos = $chars.length;
  let pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
let _ascendingId = (()=>{
  let id = 0;
  return function (len = 6){
    id++;
    let arr = Array(len).fill(0);
    arr.push(...Array.from(id.toString()));
    let str = arr.splice(arr.length - len,len).join('');
    return str;
  }
})();
function _ascendingStringId(len = 16) {
  let before = "mi__";
  let id = _ascendingId().toString();
  let str = _randomString(len - id.length - before.length);
  return before + str + id;
}


export function parseUrlParams(url = location.search){
  if(!url) return false;
  url = url.replace(/^\?/,"");
  let paramsArr = url.split("&");
  const data = {};
  paramsArr.forEach(res=>{
    const arr = res.split("=");
    const key = arr[0];
    data[key] = arr[1];
  })
  return data;
}

/**
 * 根据 location.hostname 判断当前打开的页面是否是 正式/测试 环境网址，如果是有效的网站地址，则返回当前网址，否则返回测试环境网址
 */
export function getWebHref(){
  // 是否是有效的网址
  let isValidHref = false;
  let href = "https://qa2.huodaipin.com.cn";
  if(typeof location !== "undefined" && location.hostname){
    isValidHref = /.com(.cn)?$/i.test(location.hostname)
    if(isValidHref) href = location.origin;
  }
  console.log("getWebHref()",href)
  // 返回值尾部不带/
  return href;
}

export let randomString = _randomString;
export let ascendingId = _ascendingId;
export let ascendingStringId = _ascendingStringId;

/**
 * 发送客户操作记录（客户留存数据分析埋点）
 * @param operationButtonName  {string}  操作按钮（类型）名称
 * @param operationContent {string}  操作内容描述
 * @param optionsData {object} 补充请求参数
 * @returns {boolean}
 */
export function sendCustomerOperationRecord(operationButtonName="",operationContent="", optionsData = {}){
  let url = "/api/sysUserOperationLog/addSysUserOperationLog";
  let useInfo = sessionGetUserInfo();
  let isLogin = useInfo && useInfo.customerid && useInfo.token;
  if(!isLogin) {
    // return Promise.reject( new Error("未登录"));
    return false;
  }
  let data = {
    // 客户id
    "customerId": useInfo.customerid,
    // 操作按钮名称
    "operationButtonName": operationButtonName,
    // 操作内容
    "operationContent": operationContent,
    // 类型 1：Web端；2：小程序
    "type": 1,
    // 用户id
    "userId": useInfo.userId,
    ...optionsData
  }
  axios.post(url,data)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    .then(res=>{

    })
    .catch(res=>{
      console.error(res);
    })
}
/**
 * 发送统计热门国家点击次数
 * @param cityCode  {string}  起运城市代码
 * @param countryCode {string}  目的国家代码
 */
export function sendStatisticHotCountry(cityCode="",countryCode=""){
  if(!cityCode && !countryCode) return false;
  let url = "/api/filedata/userClickVolume";
  let data = {
    // 起运城市代码
    "cityCode": cityCode,
    // 目的国家代码
    "countryCode": countryCode,
  }
  axios.post(url,data)
    .then(res=>{
      res = isObject(res.data) ? res.data : {};
      if(res.code !== 200) return Promise.reject(new Error(res.message));
      return res;
    })
    // .then(res=>{
    //
    // })
    .catch(res=>{
      console.error(res);
    })
}

let _local_id_index = 1;
export function getLocalId(){
  let i = _local_id_index++;
  return `${i}_${Date.now()}_${Math.round(Math.random() * 100)}`;
}

/**
 * 将 价格信息文本（例：1684.45/kg）以/为界限分割并返回对应格式
 * @param priceInfo
 * @returns {{unit: string, price: string}}
 */
export function splitPriceInfo(priceInfo = ""){
  let result = {price:"",unit:"",};
  if(typeof priceInfo === "number") priceInfo = `${priceInfo||""}`;
  if(typeof priceInfo !== "string" || !priceInfo.length) return result;
  if(/\//g.test(priceInfo)){
    let arr = priceInfo.split("/");
    result.price = arr[0]||"";
    result.unit = arr[1]||"";
  }else{
    result.price = priceInfo;
  }
  return result;
}

/**
 * @description 将富文本内容转化为string
 * @param {*} html 富文本
 * @returns {string}
 */
export function stripHtmlTags(html){
  let tmp = document.createElement("div");
  tmp.innerHTML = html.trim();
  return tmp.innerText || "";
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js